/**
 * User: Faris
 * Date: 6/24/13
 * Time: 12:21 PM
 */

define('app/models/Content_area',['require'],function(require) {

  return Backbone.Model.extend({

    idAttribute: 'ID',

    defaults: {
      loaded: false
    },

    url: function(){
      return '/library/ajax/get_page_content.cfm'
    },

    sync: function(method, model, options){
      options.processData = true;

      if(!options.data) {
        options.data = {
          id: this.id
        };
      }

      return Backbone.Model.prototype.sync.call(this, method, model, options);
    },

    parse: function(response, options){
      response.loaded = true;

      if(response.TEMPLATE == 'menu_list'){
        response.menu_pages = response.CHILDREN;
      } else if(response.TEMPLATE == 'menu_detail'){
        response.H1 = response.PARENT.H1;
        response.BLURB1 = response.PARENT.BLURB1;
        response.menu_pages = response.SIBLINGS;
      }

      return Backbone.Model.prototype.parse.call(this, response, options);
    }

  });

});
